import api from "../../../services/axios"

export const startSession = async (email, token) => {
  try {
    const res = await api.post("/Auth/start-session", {
      email,
      loginFrom: "WEB",
    },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    return res?.data
  } catch (error) {
    throw error?.response?.data;
  }
};

export const CheckAdmin = async () => {
  try {
    const res = await api.get("/Auth/CheckAdmin");
    return res?.data
  } catch (error) {
    throw error?.response?.data;
  }
};